import React, { useState } from 'react';
import Card from 'v3/components/Card';
import Text from 'v3/components/Text';
import { useModal } from 'hooks';
import CardHeaderComponent from '../../components/CardHeaderComponent';
import HeaderTotalSummary from '../../components/HeaderTotalSummary';
import { useFreightValues } from '../../context';
import { LabelsRow } from '../../components/LabelRows';
import { FreightItemRow } from '../../components/FreightItemRow';
import ExtraFields from '../../components/ExtraFields';
import { SummaryRow } from '../../components/SummaryRow';
import { ExtraFieldButton } from '../../components/ExtraFieldButton';
import ExtraFieldsModal from '../../components/ExtraFieldModal';

export default function ShipmentDiscountsEdit({ disableIssueRate, defaultIsOpen = false }) {
  const {
    isBRLCurrency,
    totalShipmentDiscounts,
    shipmentDiscounts,
    shipmentDiscountsExtraFields,
    setShipmentDiscountsExtraFields,
    erpExchangeValue,
    discountsTags,
    onChangeIssueRate,
  } = useFreightValues();
  const extraFieldsModal = useModal();
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  function onToggleCard() {
    setIsOpen(!isOpen);
  }

  function onRemoveField(index) {
    setShipmentDiscountsExtraFields((old) => old.filter((_, idx) => idx !== index));
  }

  return (
    <Card containerCardBoxShadow="0px 0px 10px rgba(0, 0, 0, 0.1)">
      <CardHeaderComponent
        label="Descontos ao Transportador"
        isOpen={isOpen}
        onToggleCard={onToggleCard}
        tooltipContent="Se caracteriza todo desconto que será feito depois de tirar a margem (Taxa administrativa)."
        totalsSection={
          <HeaderTotalSummary
            label="Valor Descontos"
            totalInReal={totalShipmentDiscounts?.total}
            totalInDollar={totalShipmentDiscounts?.totalDollarValue}
          />
        }
        hasTagsRow
        tagsContent={discountsTags}
      />
      {isOpen && (
        <>
          <LabelsRow />
          <FreightItemRow
            isBRLCurrency={isBRLCurrency}
            dollarToUse={erpExchangeValue}
            label="Taxa de emissão"
            onChangeValue={(_event, value) => onChangeIssueRate(value)}
            value={shipmentDiscounts.issueRate?.value}
            dollarValue={shipmentDiscounts.issueRate?.dollarValue}
            shouldDisableField={disableIssueRate}
            id="taxa-emissao"
          />
          {shipmentDiscountsExtraFields?.length > 0 ? (
            <>
              <Text type="regular" weight={500}>
                Valores extras
              </Text>
              <ExtraFields fields={shipmentDiscountsExtraFields} onRemoveField={onRemoveField} />
            </>
          ) : null}
          <SummaryRow
            label="Valor Descontos"
            totalInReal={totalShipmentDiscounts?.total}
            totalInDollar={totalShipmentDiscounts?.totalDollarValue}
            id="desconto"
          />
          <ExtraFieldButton
            id="button-abrir-valores-extras-desconto"
            openModal={() => extraFieldsModal.open()}
          />
          <ExtraFieldsModal
            extraFields={shipmentDiscountsExtraFields}
            isOpen={extraFieldsModal.isOpen}
            handleClose={extraFieldsModal.close}
            onSave={(fields) => setShipmentDiscountsExtraFields(fields)}
            isBRLCurrency={isBRLCurrency}
            dollarToUse={erpExchangeValue}
          />
        </>
      )}
    </Card>
  );
}
